/**
 * Update Banner UI Component
 * 
 * Displays a non-intrusive notification when a new service worker
 * version is available, allowing users to update immediately or defer.
 */

export class UpdateBanner {
  constructor() {
    this.element = null;
    this.worker = null;
    this.onUpdate = null;
    this.onDismiss = null;
  }

  create() {
    if (this.element) return this.element;

    this.element = document.createElement('div');
    this.element.className = 'update-banner';
    this.element.innerHTML = `
      <div class="update-banner-content">
        <span class="update-banner-message">New version available</span>
        <div class="update-banner-actions">
          <button class="update-banner-btn update-banner-update">Update Now</button>
          <button class="update-banner-btn update-banner-dismiss">Later</button>
        </div>
      </div>
    `;

    this.element.querySelector('.update-banner-update').addEventListener('click', () => {
      this.handleUpdate();
    });

    this.element.querySelector('.update-banner-dismiss').addEventListener('click', () => {
      this.hide();
      if (this.onDismiss) this.onDismiss();
    });

    return this.element;
  }

  /**
   * Show the update banner
   * @param {ServiceWorker} worker The waiting service worker
   * @param {Object} options Callbacks
   * @param {Function} options.onUpdate Called when user clicks update
   * @param {Function} options.onDismiss Called when user dismisses
   */
  show(worker, options = {}) {
    this.worker = worker;
    this.onUpdate = options.onUpdate;
    this.onDismiss = options.onDismiss;

    if (!this.element) {
      this.create();
      document.body.appendChild(this.element);
    }

    // Trigger animation
    requestAnimationFrame(() => {
      this.element.classList.add('visible');
    });
  }

  hide() {
    if (this.element) {
      this.element.classList.remove('visible');
    }
  }

  handleUpdate() {
    if (this.onUpdate) {
      this.onUpdate();
    }
    if (this.worker) {
      this.worker.postMessage({ type: 'SKIP_WAITING' });
    }
    this.hide();
  }
}

export const updateBanner = new UpdateBanner();
